// While a tutorial runs on the REAL client page nothing may change state: no form submit, no write action (add to cart, remove,
// checkout, top-up, favourite, mark read, delete …). Read-only UI (drawers, tabs, expanding rows, links) stays usable.
// Controls are blocked when they carry `data-tour-block`, are submit buttons, or name a write action in `data-action`.
export const FLAG = "data-tour-running"
export const NOTICE = "Niedostępne w trakcie samouczka"

const WRITE = /#(add(Default|Variant|Chosen)?|bulkAdd|remove\w*|checkout|topup|accept\w*|reserve\w*|delete\w*|save\w*|submit\w*|send\w*|create\w*|mark\w*|toggleFav\w*|favou?rite\w*|pay\w*|buy\w*|confirm\w*|reply\w*|closeThread|reopen\w*|revoke\w*|rotate\w*)$/

/** the control a click landed on, when it is a write control (null otherwise) */
export function blockedControl(target) {
  const el = target?.closest?.("button, a, input, [data-action], [data-tour-block]")
  if (!el || el.closest(".ls-tour")) return null
  if (el.matches("[data-tour-block], [type=submit], [type=image]")) return el
  if (el.tagName === "BUTTON" && !el.hasAttribute("type") && el.form) return el // implicit submit
  const action = el.getAttribute("data-action") || ""
  const writes = action.split(/\s+/).some((a) => {
    const [event, rest] = a.includes("->") ? a.split("->") : ["click", a]
    return event === "click" && WRITE.test(rest)
  })
  return writes ? el : null
}

/** mark it visibly disabled for the duration (restored by `unmarkAll`) */
export function mark(el) {
  if (el.hasAttribute("data-tour-blocked")) return
  el.setAttribute("data-tour-blocked", "")
  el.setAttribute("aria-disabled", "true")
  if (el.hasAttribute("title")) el.dataset.tourTitle = el.getAttribute("title")
  el.setAttribute("title", NOTICE)
}

export function unmarkAll(doc = document) {
  for (const el of doc.querySelectorAll("[data-tour-blocked]")) {
    el.removeAttribute("data-tour-blocked")
    el.removeAttribute("aria-disabled")
    if (el.dataset.tourTitle !== undefined) {
      el.setAttribute("title", el.dataset.tourTitle)
      delete el.dataset.tourTitle
    } else el.removeAttribute("title")
  }
}
